import React from "react";
import { adminApi as api } from "../../../util/api";
import { ImportModal } from "../../components/ImportModal";

export const ImportBenefitPullTypeModal = ({ onImport, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      file: {
        bytes: values.file,
      },
    };
    const res = await api.post("/admin/benefit_pull_types/import.json", params);

    if (onImport) {
      onImport(res.data?.meta?.message, res.data?.meta?.error_details);
    }
  };

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Import Benefit Pull Types..."
      exampleDownloadPath="/admin/benefit_pull_types/example"
    />
  );
};
